/* ─────────────────────────────────────────
   section-product-ymal.js
   Static grid on desktop/tablet.
   Carousel (2-up) on mobile only.
───────────────────────────────────────── */

(function () {
  'use strict';

  const MOBILE_BP = 599;

  function initYmal(section) {
    const grid    = section.querySelector('.product-ymal__grid');
    const wrap    = section.querySelector('.product-ymal__track-wrap');
    const prevBtn = section.querySelector('.product-ymal__nav-btn[aria-label="Previous"]');
    const nextBtn = section.querySelector('.product-ymal__nav-btn[aria-label="Next"]');
    const items   = section.querySelectorAll('.product-ymal__item');

    if (!grid || !items.length) return;

    let currentPage = 0;
    let isMobile    = window.innerWidth <= MOBILE_BP;

    // ── Background colour ──
    const bg = section.dataset.bg;
    if (bg) section.setAttribute('data-bg', bg);

    // ── Carousel logic (mobile only) ──
    function totalPages() {
      // Always show 2 per page on mobile
      return Math.ceil(items.length / 2);
    }

    function getItemWidth() {
      // (wrapWidth - 1 gap) / 2
      return (wrap.offsetWidth - 12) / 2;
    }

    function updateTrack() {
      if (!isMobile) {
        grid.style.transform = '';
        return;
      }
      const itemWidth = getItemWidth();
      // Each page advances by 2 items worth (2 * itemWidth + 2 * gap)
      const offset = currentPage * 2 * (itemWidth + 12);
      grid.style.transform = `translateX(-${offset}px)`;
    }

    function updateButtons() {
  if (!isMobile) return;
  if (prevBtn) prevBtn.disabled = false;
  if (nextBtn) nextBtn.disabled = false;
}

function goNext() {
  currentPage = (currentPage + 1) % totalPages();
  updateTrack();
  updateButtons();
}

function goPrev() {
  currentPage = (currentPage - 1 + totalPages()) % totalPages();
  updateTrack();
  updateButtons();
}

    if (prevBtn) prevBtn.addEventListener('click', goPrev);
    if (nextBtn) nextBtn.addEventListener('click', goNext);

    // ── Touch / swipe ──
    let touchStartX = 0;
    let touchDeltaX = 0;

    grid.addEventListener('touchstart', e => {
      touchStartX = e.touches[0].clientX;
      touchDeltaX = 0;
    }, { passive: true });

    grid.addEventListener('touchmove', e => {
      touchDeltaX = e.touches[0].clientX - touchStartX;
    }, { passive: true });

    grid.addEventListener('touchend', () => {
      if (!isMobile) return;
      if (touchDeltaX < -50) goNext();
      if (touchDeltaX > 50)  goPrev();
    });

    // ── Resize: switch between grid and carousel ──
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        const wasGobile = isMobile;
        isMobile = window.innerWidth <= MOBILE_BP;

        if (!isMobile) {
          // Reset carousel state when returning to desktop/tablet
          currentPage = 0;
          grid.style.transform = '';
        } else {
          currentPage = Math.min(currentPage, Math.max(0, totalPages() - 1));
          updateTrack();
          updateButtons();
        }
      }, 150);
    });

    // ── Add to cart ──
    section.querySelectorAll('.ymal-card__atc').forEach(btn => {
      btn.addEventListener('click', async () => {
        const variantId = btn.dataset.variantId;
        if (!variantId) return;

        const origText = btn.textContent.trim();
        btn.textContent = 'Adding…';
        btn.disabled = true;

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });

          if (!res.ok) throw new Error('Cart error');

          btn.textContent = 'Added!';
          document.dispatchEvent(new CustomEvent('cart:updated'));

          setTimeout(() => {
            btn.textContent = origText;
            btn.disabled = false;
          }, 1800);

        } catch (err) {
          console.error('YMAL ATC error:', err);
          btn.textContent = 'Error';
          setTimeout(() => {
            btn.textContent = origText;
            btn.disabled = false;
          }, 2500);
        }
      });
    });

    // ── Init ──
    updateButtons();
  }

  function init() {
    document.querySelectorAll('.product-ymal').forEach(initYmal);
  }

  if (document.readyState === 'complete') {
    init();
  } else {
    document.addEventListener('readystatechange', () => {
      if (document.readyState === 'complete') init();
    });
  }

})();